// extracted by mini-css-extract-plugin
export default {"page":"Page_page__6h+8u","section":"Page_section__uXqzZ"};